import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "../redux/rootReducer";
import { DbKeyType, loadAllDb } from "../redux/dataBackend";

type Hash = { [key in string]: Object }

const useAllDbs = (call: boolean): { [key in DbKeyType]: Hash | null } => {
  const dispatch = useDispatch();
  useEffect(() => { if (call) dispatch(loadAllDb()) }, [call])
  const users = useSelector((state: RootState) => state.userDb.users);
  const folders = useSelector((state: RootState) => state.folderDb.folders);
  const books = useSelector((state: RootState) => state.bookDb.books);
  const sheets = useSelector((state: RootState) => state.sheetDb.sheets);
  const sheetInformations = useSelector((state: RootState) => state.sheetInformationDb.sheetInformations);
  const palettes = useSelector((state: RootState) => state.paletteDb.palettes);
  const cardTemplates = useSelector((state: RootState) => state.cardTemplateDb.cardTemplates);
  const cardTemplateAttributes = useSelector((state: RootState) => state.cardTemplateAttributeDb.cardTemplateAttributes);
  const cardTemplateShapes = useSelector((state: RootState) => state.cardTemplateShapeDb.cardTemplateShapes);
  const cards = useSelector((state: RootState) => state.cardDb.cards);
  const cardAttributes = useSelector((state: RootState) => state.cardAttributeDb.cardAttributes);
  const cardShapes = useSelector((state: RootState) => state.cardShapeDb.cardShapes);
  const memoCardContents = useSelector((state: RootState) => state.memoCardContentDb.memoCardContents);
  const uiCardItems = useSelector((state: RootState) => state.uiCardItemDb.uiCardItems);
  const drawCardContents = useSelector((state: RootState) => state.drawCardContentDb.drawCardContents);
  const uiCardSampleDatas = useSelector((state: RootState) => state.uiCardSampleDataDb.uiCardSampleDatas);
  const cardCodeTemplates = useSelector((state: RootState) => state.cardCodeTemplateDb.cardCodeTemplates);
  const cardCodes = useSelector((state: RootState) => state.cardCodeDb.cardCodes);
  const arrows = useSelector((state: RootState) => state.arrowDb.arrows);
  const albums = useSelector((state: RootState) => state.albumDb.albums);
  const images = useSelector((state: RootState) => state.imageDb.images);
  const sheetTrees = useSelector((state: RootState) => state.sheetTreeDb.sheetTrees);
  const relationUserFolders = useSelector((state: RootState) => state.relationUserFolderDb.relationUserFolders);
  const relationUserBooks = useSelector((state: RootState) => state.relationUserBookDb.relationUserBooks);
  const relationUserPalettes = useSelector((state: RootState) => state.relationUserPaletteDb.relationUserPalettes);
  const relationUserCardTemplates = useSelector((state: RootState) => state.relationUserCardTemplateDb.relationUserCardTemplates);
  const relationFolderBooks = useSelector((state: RootState) => state.relationFolderBookDb.relationFolderBooks);
  const relationPaletteCardTemplates = useSelector((state: RootState) => state.relationPaletteCardTemplateDb.relationPaletteCardTemplates);
  const relationUserAlbums = useSelector((state: RootState) => state.relationUserAlbumDb.relationUserAlbums);
  const relationUserImages = useSelector((state: RootState) => state.relationUserImageDb.relationUserImages);
  const relationAlbumImages = useSelector((state: RootState) => state.relationAlbumImageDb.relationAlbumImages);
  const latelyCardTemplates = useSelector((state: RootState) => state.latelyCardTemplateDb.latelyCardTemplates);
  const latelyImages = useSelector((state: RootState) => state.latelyImageDb.latelyImages);
  const jointBooks = useSelector((state: RootState) => state.jointBookDb.jointBooks);
  const palettePermissions = useSelector((state: RootState) => state.palettePermissionDb.palettePermissions);
  const cardTemplatePermissions = useSelector((state: RootState) => state.cardTemplatePermissionDb.cardTemplatePermissions);
  const jointPalettes = useSelector((state: RootState) => state.jointPaletteDb.jointPalettes);
  const statusJointPalettes = useSelector((state: RootState) => state.statusJointPaletteDb.statusJointPalettes);
  const standbyPaletteJoineds = useSelector((state: RootState) => state.standbyPaletteJoinedDb.standbyPaletteJoineds);
  const standbyCardTemplateJoineds = useSelector((state: RootState) => state.standbyCardTemplateJoinedDb.standbyCardTemplateJoineds);
  const standbyRelationPaletteCardTemplateJoineds = useSelector((state: RootState) => state.standbyRelationPaletteCardTemplateJoinedDb.standbyRelationPaletteCardTemplateJoineds);
  const standbyPalettePermissionJoineds = useSelector((state: RootState) => state.standbyPalettePermissionJoinedDb.standbyPalettePermissionJoineds);
  const standbyCardTemplatePermissionJoineds = useSelector((state: RootState) => state.standbyCardTemplatePermissionJoinedDb.standbyCardTemplatePermissionJoineds);
  const userConditions = useSelector((state: RootState) => state.userCondition.userConditions);
  const notes = useSelector((state: RootState) => state.noteDb.notes);

  const allDbs: { [key in DbKeyType]: Hash | null } = {
    users,
    folders,
    books,
    sheets,
    sheetInformations,
    palettes,
    cardTemplates,
    cardTemplateAttributes,
    cardTemplateShapes,
    cards,
    cardAttributes,
    cardShapes,
    memoCardContents,
    uiCardItems,
    drawCardContents,
    uiCardSampleDatas,
    cardCodeTemplates,
    cardCodes,
    arrows,
    albums,
    images,
    sheetTrees,
    relationUserFolders,
    relationUserBooks,
    relationUserPalettes,
    relationUserCardTemplates,
    relationFolderBooks,
    relationPaletteCardTemplates,
    relationUserAlbums,
    relationUserImages,
    relationAlbumImages,
    latelyCardTemplates,
    latelyImages,
    jointBooks,
    palettePermissions,
    cardTemplatePermissions,
    jointPalettes,
    statusJointPalettes,
    standbyPaletteJoineds,
    standbyCardTemplateJoineds,
    standbyRelationPaletteCardTemplateJoineds,
    standbyPalettePermissionJoineds,
    standbyCardTemplatePermissionJoineds,
    userConditions,
    notes
  }

  return allDbs;
}

export default useAllDbs;
